import { ItemFromCms } from "../ts/interfaces"
import { setLs, getLs } from "./localStorage"
import { getCookie } from "./klaviyo"

export const paramIsValid = (id: string, expiry: string): boolean => {
  return !!id && !!expiry && new Date() < new Date(expiry)
}

export const getParamMetaData = async (
  includeKeys?: string[]
): Promise<
  {
    key: string
    value: String | number
  }[]
> => {
  const metadata: { key: string; value: String | number }[] = []

  const utm = getLs("utm")
  const campaign = getLs("campaign")
  const campaignId = campaign?.id
  const campaignExpiry = campaign?.expiry
  const campaignSrc = campaign?.source

  if (campaignId && paramIsValid(campaignId, campaignExpiry)) {
    metadata.push({ key: "campaignId", value: campaignId })
    if (campaignSrc) {
      metadata.push({ key: "campaignSrc", value: campaignSrc })
    }
  }

  const personaId = getLs("persona")?.id
  if (personaId) {
    metadata.push({ key: "personaId", value: personaId })
  }

  let fbp = getCookie("_fbp")
  let fbc = getCookie("_fbc")
  if (!fbc) {
    fbc = getFbc()
  }
  if (fbc) {
    metadata.push({ key: "fbc", value: fbc })
  }
  if (fbp) {
    metadata.push({ key: "fbp", value: fbp })
  }

  if (utm) {
    const vals = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
      "utm_id",
    ]
    vals.forEach(key => {
      if (utm[key]) {
        metadata.push({ key, value: utm[key] })
      }
    })
  }

  const sscid = getLs("sscid")
  const sscidId = sscid?.id
  const sscidExpiry = sscid?.expiry
  if (sscidId && paramIsValid("sscid", sscidExpiry)) {
    metadata.push({ key: "sscid", value: sscidId })
  }

  includeKeys = includeKeys || []

  includeKeys.forEach(k => {
    const value = getLs(k)?.value
    if (value !== null && value !== undefined) {
      metadata.push({ key: k, value: value })
    }
  })

  return metadata
}

export const getFbc = () => {
  const fbc = getLs("fbc")
  if (fbc && paramIsValid("fbc", fbc.expiry)) {
    return fbc.value
  }
  return ""
}

export const getFreshdeskQueryParams = () => {
  let params = { nonce: "", state: "" }

  if (window && window.location) {
    const url = new URL(window.location.href)
    const searchParams = url.searchParams
    params.nonce = searchParams.get("nonce") || ""
    params.state = searchParams.get("state") || ""
  }

  return params
}

export const getQueryParam = (key: string) => {
  let param = ""

  if (typeof window !== "undefined" && window.location) {
    const url = new URL(window.location.href)
    const searchParams = url.searchParams
    param = searchParams.get(key) || ""
  }

  return param
}
